import React, { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";
import { useTranslation } from "react-i18next";

const BringToTop = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      className={`fixed bottom-8 right-8 w-14 h-14 bg-golden border-none rounded-full text-white cursor-pointer flex items-center justify-center shadow-lg transition-all duration-300 ease-in-out z-[999999] ${
        isVisible
          ? "opacity-100 visible translate-y-0"
          : "opacity-0 invisible translate-y-5"
      } hover:-translate-y-1 hover:shadow-xl hover:scale-110 active:translate-y-0 md:bottom-6 md:right-6 md:w-12 md:h-12 sm:bottom-4 sm:right-4 sm:w-10 sm:h-10`}
      onClick={scrollToTop}
      aria-label={t("actions.backToTop")}
    >
      <ArrowUp className="w-6 h-6 md:w-5 md:h-5 sm:w-4 sm:h-4" />
    </button>
  );
};

export default BringToTop;
